import { AutogenModelOrganizationToken, AutogenRowOrganizationToken } from "./autogen/AutogenModelOrganizationToken";

export class ModelOrganizationToken extends AutogenModelOrganizationToken<RowOrganizationToken> {
	constructor() {
		super(RowOrganizationToken);
	}
}

export class RowOrganizationToken extends AutogenRowOrganizationToken {
}